import { render } from "./EmployeeDocuments.vue?vue&type=template&id=32e0be0f&scoped=true"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js"

import "./EmployeeDocuments.vue?vue&type=style&index=0&id=32e0be0f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e0be0f"]])

export default __exports__